export const TransactionStatus = {
  Processing: "processing",
  Settled: "settled",
  Returned: "returned",
  Canceled: "canceled",
} as const;
export type TransactionStatus =
  (typeof TransactionStatus)[keyof typeof TransactionStatus];
